module.exports = __webpack_public_path__ + "src/assets/img/03_treibhaus.078311f5.svg";